<ap-modal #baseModal
          [appModalId]="'dst-disclosure-viewer'"
          [ariaLabel]="'Disclosure viewer'"
          [closable]="false"
          [style]="{'width': 'min(900px, 65vw)', 'max-height': '88vh'}"
          [contentStyle]="{'height': '82vh', 'overflow': 'auto'}"
          (onClose)="closeModalOk('dst-disclosure-viewer')">
  <div class="disc-modal-viewer-body">
    @if (ready) {
<div class="viewport-wrapper">
      <dst-create-disclosure-shared class="modal-viewer" [rowObj]="rowObject"></dst-create-disclosure-shared>
    </div>
}
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'text'" [label]="'CLOSE'" (onClick)="closeModalOk('dst-disclosure-viewer')"></ap-button>
  </ng-template>
</ap-modal>

